export const enum SourcesSearchParametersEnum {
    CompanyIdList = 'companies-ids',
    CclStatus = 'ccl-status',
    SourceIdList = 'source-ids',
    isNewCompanies = 'is-new-companies',
}
